module.exports = __webpack_public_path__ + "../static/img/logobar.b7f85a9f.png";